import APP_CONSTANTS from "src/application/shared/app_constants";
import loadCensoredWords from "../loadCensoredWords";

let censored_words_en = new Set([
  "baiser",
  "bander",
  "bigornette",
  "bite",
  "bitte",
  "bloblos",
  "bordel",
  "bourré",
  "bourrée",
  "brackmard",
  "branlage",
  "branler",
  "branlette",
  "branleur",
  "branleuse",
  "brouter le cresson",
  "caca",
  "chatte",
  "chiasse",
  "chier",
  "chiottes",
  "clito",
  "clitoris",
  "con",
  "connard",
  "connasse",
  "conne",
  "couilles",
  "cramouille",
  "cul",
  "déconne",
  "déconner",
  "emmerdant",
  "emmerder",
  "emmerdeur",
  "emmerdeuse",
  "enculé",
  "enculée",
  "enculeur",
  "enculeurs",
  "enfoiré",
  "enfoirée",
  "étron",
  "fille de pute",
  "fils de pute",
  "folle",
  "foutre",
  "gerbe",
  "gerber",
  "gouine",
  "grande folle",
  "grogniasse",
  "gueule",
  "jouir",
  "la putain de ta mère",
  "MALPT",
  "ménage à trois",
  "merde",
  "merdeuse",
  "merdeux",
  "meuf",
  "nègre",
  "negro",
  "nique ta mère",
  "nique ta race",
  "palucher",
  "pédale",
  "pédé",
  "péter",
  "pipi",
  "pisser",
  "pouffiasse",
  "pousse-crotte",
  "putain",
  "pute",
  "ramoner",
  "sac à foutre",
  "sac à merde",
  "salaud",
  "salope",
  "suce",
  "tapette",
  "tanche",
  "teuch",
  "tringler",
  "trique",
  "troncher",
  "trou du cul",
  "turlute",
  "zigounette",
  "zizi",
]);

if (!censored_words_en.keys.length) {
  async () => {
    try {
      censored_words_en = await loadCensoredWords(
        APP_CONSTANTS.CENSORED_WORDS_FETCH_URLS.FR
      );
    } catch (error) {
      throw new Error(`❌ Error loading censored words [FR]! ${error}`);
    }
  };
}

export default censored_words_en;
